import { BottomNav } from './BottomNav';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export const AppLayout = ({ children, title, showSearch = false }) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Desktop Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="lg:ml-64">
        <Header title={title} showSearch={showSearch} />
        <main className="page-container">
          {children}
        </main>
      </div>
      
      {/* Mobile Bottom Nav */}
      <BottomNav />
    </div>
  );
};
